import { usePushNotifications } from '@/hooks/usePushNotifications';

/**
 * Invisible component that initializes push notifications.
 * Must be rendered inside AuthProvider.
 */
export function PushNotificationInit() {
  usePushNotifications();
  return null;
}
